import React, {useEffect, useState} from "react";
import API from "../../../api";
import {ArrowsUpDownIcon} from "@heroicons/react/20/solid";
import {AuthComponents} from "../../../lib/_sso";
import ManageResult from "./ManageResult";

const AttendanceListWithResults = ({items, actionButtons, event, onReload}) => {
  const [sortByName, setSortByName] = useState(true);
  const [cpdConfigs, setCpdConfigs] = useState([]);

  useEffect(() => {
    API.settings.getCPDConfig().then(res => {
      setCpdConfigs(res.filter(a => a.role._id === event.cpdRole))
    })
  }, [event]);

  const startPassAll = () => {

  }

  if (items.length === 0) {
    return (
      <div className={"p-2 text-center"}>There are no items to display</div>
    );
  }
  return (
    <table className="tableClass">
      <thead>
      <tr className="tableHeadRowClass">
        <th
          onClick={() => setSortByName(!sortByName)}
          className="tableHeadCellClass flex gap-1"
        >
          Name
          {sortByName ? (
            <ArrowsUpDownIcon className="h-4 text-green-500"/>
          ) : (
            <ArrowsUpDownIcon className="h-4"/>
          )}
        </th>
        <th className={"tableHeadCellClass"}>
          <div className={"flex justify-between"}>
            <div>Result</div>
            {/*<AuthComponents.Can scope={"events:write"}>*/}
            {/*  <button className={"rounded border p-1 text-xs dark:border-zinc-500"} onClick={() => startPassAll()}>*/}
            {/*    Pass All*/}
            {/*  </button>*/}
            {/*</AuthComponents.Can>*/}
          </div>
        </th>
        <th className="tableHeadCellClass">Change to</th>
      </tr>
      </thead>
      <tbody className="tableBodyClass">
      {items.sort((a, b) => {
        if (a.lastName > b.lastName) {
          return sortByName ? 1 : -1;
        } else if (a.lastName < b.lastName) {
          return sortByName ? -1 : 1;
        }
        return 0;
      }).map((item) => {
        return (
          <tr key={item._id} className="tableBodyRowClass">
            <td className={`p-2 ${item.onCall && "oncall"} ${!item.onCall && "offcall"} ${!item.operational && "nonOp"}`}>
              {item.firstName} {item.lastName}{" "}
              {item.callsign && (
                <span className="italic">({item.callsign})</span>
              )}
            </td>
            <td>
              <ManageResult
                cpdConfigs={cpdConfigs}
                eventId={event._id}
                event={event}
                member={item}
                onResultUpdate={onReload}
              />
            </td>
            <td className="px-1 py-2">
              <div
                className="flex flex-wrap items-center space-y-1 text-center align-middle text-xs md:flex-nowrap md:space-y-0">
                {actionButtons.map((a, i) => {
                  return (
                    <button
                      key={i}
                      className={a.className + " w-full"}
                      onClick={() => a.onClick(item)}
                    >
                      {a.title}
                    </button>
                  );
                })}
              </div>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  );
};
export default AttendanceListWithResults;